module.exports = __webpack_public_path__ + "static/img/zitu.35c9b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zitu.png
// module id = 9iYg
// module chunks = 0